module.exports = __webpack_public_path__ + "img/fosunCredit.388376f0.png";